const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;
const InitPageTest: number = 0;

const getPageInit = isDevelopment ? InitPageTest : 0;

const SiteConfig: ISiteConfig = {
    InitPage: getPageInit,
    TotalPage: 0,
    TotalPageBar: 5
} as ISiteConfig;



const AutoDataTemp: IAutoCR = {
    init: false,
    typeDocument: '1',
    identification: '',
    acceptTerms: false,
    offerType: '',

    filterData: '',
    searchFilter: '',

    //STEP2
    plan: '',
    vehicleBrand: '',
    otherVehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleStatus: '',
    vehicleUse: '',
    vehicleDevice: '',
    vehicleValue: '',
    deductible: '',
    quotas: '',
    //
    typeDocumentInsured: '',
    identificationInsured: '',
    firstName: '',
    lastName: '',
    mail: '',
    phone: '',
    sex: '',
    civilStatus: '',

    //
    username: '',
    idBrokerage: 0,
    idUser: 0,
    nameBrokerage: '',
    catPlanConfig: [],
    lstPlanConfig: [],
    catBranch: [],
    catModel: [],
    catYear: [],
    catUse: [],
    catDeductible: [],
    catQuotas: [],
    catCoverage: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    isDatasheet: false,
    //
    lstCoverageExt: [],
    rates: {},
    isRate: false,

    idPoliza: 0,
    loadedPolicy: false,
    isEdit: false,
    saved: false,

    //
    
    existPol : false,
    dataPol: {},
    catDiscount:[],
    discount: 0,
    idDiscount: 0,
    maxDiscount: 0,
    currency:''

}

const AutoWithDataTemp: IAutoCR = {
    init: false,
    typeDocument: '1',
    identification: '4-0227-0802',
    acceptTerms: false,
    offerType: '',

    filterData: '',
    searchFilter: '',

    //STEP2
    plan: '',
    vehicleBrand: '',
    otherVehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleStatus: '',
    vehicleUse: '',
    vehicleDevice: '',
    vehicleValue: '',
    deductible: '',
    quotas: '',

    //
    typeDocumentInsured: '',
    identificationInsured: '',
    firstName: '',
    lastName: '',
    mail: '',
    phone: '',
    sex: '',
    civilStatus: '',

    //
    username: 'AARAYA',
    idBrokerage: 130,
    idUser: 0,
    nameBrokerage: 'CORREDURÍA DE SEGUROS METROPOLITANOS',
    catPlanConfig: [],
    lstPlanConfig: [],
    catBranch: [],
    catModel: [],
    catYear: [],
    catUse: [],
    catDeductible: [],
    catQuotas: [],
    catCoverage: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    isDatasheet: false,

    //
    lstCoverageExt: [],
    rates: {},
    isRate: false,

    idPoliza: 0,
    loadedPolicy: false,
    isEdit: false,
    saved: false,
    //

    existPol : false,
    dataPol: {},
    catDiscount:[],
    discount: 0,
    idDiscount: 0,
    maxDiscount: 0,

    //
     //
     currency:''
}

const AutoDataLoad = {
    existPolicy: true,
    plan: '474',
    vehicleBrand: '1',
    vehicleModel: '168',
    vehicleYear: '2025',
}


const setObj = () => (setData && isDevelopment) ? ({ ...AutoWithDataTemp }) : ({ ...AutoDataTemp });

const AutoDefault: IAutoCR = setObj();

export { AutoDefault, SiteConfig, AutoDataLoad };